import { render, staticRenderFns } from "./RoomCalcelModal.vue?vue&type=template&id=5f52d50b&scoped=true"
import script from "./RoomCalcelModal.vue?vue&type=script&lang=js"
export * from "./RoomCalcelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52d50b",
  null
  
)

export default component.exports